import { useState } from "react";
import { Title } from "components/Title";
import { ContentTitle } from "components/ContentTitle";
import HomeBackground from "assets/HomeBackground.png";
import { useSelector } from "react-redux";
import { RootState } from "state/store";
import { LoaderIndicator } from "components/LoaderIndicator";
import { useTitleChange } from "hooks/useTitleChange";
import { AutoInputComplete } from "components/AutoInputComplete";
import { Box, Button, IconButton, Modal, useMediaQuery } from "@mui/material";
import { Masonry } from "@mui/lab";
import { Filter } from "icons";
import { AnimateTourCard } from "components/AnimateTourCard";
import { useFilterItems } from "./hooks/useFilterItems";
import { useFilter } from "./hooks/useFilter";

export const Tours = () => {
  useTitleChange("Tours");
  const [loading, setLoading] = useState(true);
  const { packages } = useSelector((state: RootState) => state.PackageReducer);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { durationDayItems, modalitiesItems, tourTypesItems } = useFilterItems(packages);
  const { filteredPackages, handleFilterChange, handleSearch } = useFilter(packages, setLoading);

  return (
    <>
      <LoaderIndicator isLoading={loading} />
      {!loading && (
        <>
          <ContentTitle title="Tours" img={HomeBackground} />
          <Title>Encuentra las mejores ofertas para tu próximo viaje</Title>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            justifyContent="center"
            alignItems="center"
            gap={5}
            marginX={5}
            marginBottom={20}>
            <Box
              display="flex"
              gap={3}
              justifyContent="center"
              alignItems="flex-end"
              width={isMobile ? "100%" : undefined}>
              <AutoInputComplete
                label="Duración"
                options={durationDayItems}
                onChange={v => handleFilterChange("durationDay", v)}
              />
              {isMobile && (
                <IconButton onClick={handleOpen}>
                  <Filter />
                </IconButton>
              )}
            </Box>
            {!isMobile && (
              <>
                <AutoInputComplete
                  label="Tipo de Tour"
                  options={tourTypesItems}
                  onChange={value => handleFilterChange("tourType", value)}
                />
                <AutoInputComplete
                  label="Modalidad"
                  options={modalitiesItems}
                  onChange={value => handleFilterChange("modality", value)}
                />
              </>
            )}
            <Button
              onClick={handleSearch}
              color="secondary"
              variant="outlined"
              aria-label="buscar"
              sx={{
                borderColor: "black",
                borderRadius: 0,
                width: 160,
                color: "black"
              }}>
              Buscar
            </Button>
          </Box>
          <Modal
            keepMounted
            open={open}
            onClose={handleClose}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginInline: 3
            }}>
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              bgcolor="white"
              padding={3}
              borderRadius={3}>
              <AutoInputComplete
                label="Tipo de Tour"
                options={tourTypesItems}
                onChange={value => handleFilterChange("tourType", value)}
              />
              <AutoInputComplete
                label="Modalidad"
                options={modalitiesItems}
                onChange={value => handleFilterChange("modality", value)}
              />
            </Box>
          </Modal>
          <Box display="flex" justifyContent="center">
            <Masonry columns={isMobile ? 1 : 3} spacing={5} sequential sx={{ maxWidth: 1100 }}>
              {filteredPackages.map((v, index) => (
                <AnimateTourCard
                  key={v.id}
                  isExtended={index % 2 === 0}
                  image={v.salePhoto}
                  title={v.name}
                  name={v.name}
                  description={v.description.generalDescription}
                  price={v.name}
                />
              ))}
            </Masonry>
          </Box>
        </>
      )}
    </>
  );
};
